/** @file tileOnionImages: the previous and next tile of the same entry, for the onion under the pixels. */
import type { ImageSlot } from '@zilo/pose3d-format/types/facet';
import type { Image } from '@zilo/pose3d-image-io/types/image';
import type { LoadedBundle } from '@zilo/pose3d-runtime-babylon/bundle/loadedBundle';
import { thumbnailOf } from '../../panels/art/thumbnailOf';

/**
 * The neighbours of `slot` in `entrySlots` (tile order): each one's open draft when `draftOf` has one (unsaved strokes
 * show), else its tile in the preview; empty neighbours and images of another size are left out.
 */
export function tileOnionImages(slot: ImageSlot, entrySlots: readonly ImageSlot[], bundle: LoadedBundle | null, draftOf: (s: ImageSlot) => Image | undefined): Image[] {
  const i = entrySlots.findIndex((s) => s.key === slot.key);
  if (i < 0) return [];
  const out: Image[] = [];
  for (const s of [entrySlots[i - 1], entrySlots[i + 1]]) {
    if (s === undefined) continue;
    const image = draftOf(s) ?? (s.status === 'filled' ? thumbnailOf(bundle, s) : null);
    if (image !== null && image.width === slot.size[0] && image.height === slot.size[1]) out.push(image);
  }
  return out;
}
